import { inject, Injectable } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import TurndownService from "turndown";
import { EventBasic } from "./models/events/event-basic.model";


@Injectable({
    providedIn: 'root'
})
export class MetaDataService {
    private readonly _metadata = inject(Meta)

    private stripMetadata() {
        this._metadata.removeTag("name='robots'");
        this._metadata.removeTag("name='description'");
        this._metadata.removeTag("property='og:title'");
        this._metadata.removeTag("property='og:description'");
        this._metadata.removeTag("property='og:url'");
        this._metadata.removeTag("name='twitter:title'");
        this._metadata.removeTag("name='twitter:description'");
        this._metadata.removeTag("name='twitter:image'");
    }

    constructMetaData(metaData: MetaDataObject){
        this.stripMetadata();

        const title = `${metaData?.title}`
        const description = new TurndownService().turndown(metaData?.description);
        const url = `${metaData?.url}`;
        const image = `${metaData?.image}`;

        this._metadata.addTags([
        { name: 'robots', content: 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1' },
        { name: 'description', content: description },
        { property: 'og:title', content: title },
        { property: 'og:description', content: description },
        { property: 'og:url', content: url },
        { property: 'og:image', content: image }, 
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        { name: 'twitter:image', content:''}
        ])
    }

    constructMetaDataForEvent(event: EventBasic){
        this.stripMetadata();

        const title = `${event?.eventHost.eventSystem.name}${event?.eventHost.display ? ` - ${event.eventHost.name}` : ''}: ${event?.name}`
        const description = new TurndownService().turndown(event?.promoDescription ?? '');
        const url = `https://www.lrptickets.co.uk/events/${event?.eventLink}`;
        const image = `${event?.ogCard}`;

        this.constructMetaData({
            title,
            description,
            url,
            image
        });
    }
}

export interface MetaDataObject {
    title:string;
    description: string;
    url: string;
    image: string;
}